import { AppConfig } from "../../app.config";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Injectable } from "@angular/core";
import { Globals } from "../../models/lib/globals";
import {
  AccountService,
  SystemLoginRequest,
  UserService,
} from "../../services/api.client.generated";
import { take } from "rxjs/operators";
import { environment as env } from "../../../environments/environment";
import { responseHandler } from "../../utils/responseHandler";
import { SignalRService } from "../../services/signalr.service";

const jwt = new JwtHelperService();

@Injectable()
export class LoginService {
  config: any;
  isFetching: boolean = false;
  _errorMessage: string = "";
  ipAddress!: string;

  constructor(
    appConfig: AppConfig,
    private globals: Globals,
    private router: Router,
    private accountService: AccountService,
    private userService: UserService,
    private signalrService: SignalRService,
  ) {
    this.config = appConfig.getConfig();
  }

  get errorMessage() {
    return this._errorMessage;
  }

  set errorMessage(val: string) {
    this._errorMessage = val;
  }

  isAuthenticated() {
    const token = localStorage.getItem("token");
    if (!token) {
      return;
    }
    const tokenExpired = jwt.isTokenExpired(token);
    if (tokenExpired) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    }
    return !tokenExpired;
  }

  async loginUser(creds: any) {
    // We check if app runs with backend mode
    this.requestLogin();
    const ctrl = this;
    if (creds.email.length <= 0 || creds.password.length <= 0) {
      this.loginError("Something was wrong. Try again");
    }
    this.isFetching = true;

    this.accountService
      .login(
        env.apiVersion,
        new SystemLoginRequest({
          userName: creds.email,
          password: creds.password,
          ipAddress: creds.ipAddress,
        }),
      )
      .pipe(take(1))
      .subscribe(
        responseHandler(
          (result: any) => {
            ctrl.receiveToken(result.object);
          },
          () => {
            this.isFetching = false;
            ctrl.loginError("Username or Password is invalid.");
          },
        ),
      );
  }

  async receiveToken(token: any) {
    let user: any = {};
    // We check if app runs with backend mode
    user = {
      email: this.config.auth.email,
    };
    localStorage.setItem("token", token);
    this.isFetching = true;
    this.userService
      .loggedInUser(env.apiVersion)
      .pipe(take(1))
      .subscribe((result) => {
        this.isFetching = false;
        Object.assign(user, result.object);
        const decodedToken = jwt.decodeToken(token);
        user.privileges = JSON.parse(decodedToken.Privileges);
        this.globals.updateUser(user);

        if (user.roles.length === 0) {
          this.logoutUser();
          this.loginError(
            "Sorry you do not have roles associated with your user.",
          );
          this.isFetching = false;
          return;
        }

        this.signalrService.startConnection();

        this.receiveLogin();
      });
  }

  logoutUser() {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    this.signalrService.discconecctHub();
    this.isFetching = false;
    this.router.navigate(["/login"]);
  }

  loginError(payload: any) {
    this.isFetching = false;
    this.errorMessage = payload;
  }

  receiveLogin() {
    this.isFetching = false;
    this.errorMessage = "";
    this.router.navigate(["/app/landing/landingPage"]);
  }

  requestLogin() {
    this.isFetching = true;
  }
}
